import { render } from "./AddTeamMember.vue?vue&type=template&id=044b6134"
import script from "./AddTeamMember.vue?vue&type=script&lang=js"
export * from "./AddTeamMember.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__